module.exports = __webpack_public_path__ + "Roboto-LightItalic.woff?f6dd13d54d88ff5668074e3ea6d7932a";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/LightItalic/Roboto-LightItalic.woff?v=2.137
// module id = 676
// module chunks = 7